var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{attrs:{"label":_vm.label,"outlined":"","dense":"","hide-details":"","items":_vm.medicalOrderTemplates,"item-text":"description","item-value":"id","disabled":_vm.isLoading},model:{value:(_vm.selectedMedicalOrderTemplate),callback:function ($$v) {_vm.selectedMedicalOrderTemplate=$$v},expression:"selectedMedicalOrderTemplate"}})
}
var staticRenderFns = []

export { render, staticRenderFns }